/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Minus, Plus, Trash2 } from "lucide-react";
import { ReactNode, useEffect, useId, useRef, useState } from "react";
import { TreeDetailsStructure } from "../tree-details-structure/tree-details-structure";
import { Button } from "@/components/ui/button";
import { useResetTreeSelect } from "@/global-data/use-reset-tree-select";

export const TreeCollapsible = ({
  children,
  name,
  type,
  config,
  jsonData,
  setActiveRef,
  onTreeChange,
  parentKey,
  onTreeMutation,
  treeId,
  count,
  defaultOpen,
  onTreeFormSubmit,
  erp_mapping_value,
  erpListData,
  cardinality,
  domainType,
  orderTypeList,
  order_type,
  parentOrderType,
  entityCardinality,
  support_multi_doc_type,
  document_types,
  data_type,
}: {
  children: ReactNode;
  name: string;
  erpListData: string[];
  type: string;
  config: any;
  entityCardinality?: any;
  jsonData?: any;
  setActiveRef: any;
  parentKey: string;
  treeId: string;
  order_type?: any;
  parentOrderType?: any;
  onTreeChange: (prop: any) => void;
  onTreeMutation: (prop: any) => void;
  onTreeFormSubmit: (prop: any, prop2?: any) => void;
  count?: number;
  defaultOpen: boolean;
  erp_mapping_value?: any;
  cardinality?: any;
  domainType?: any;
  orderTypeList?: any;
  document_types?: string;
  support_multi_doc_type: boolean;
  data_type?: any;
}) => {
  const { isReset, setIsReset } = useResetTreeSelect();

  const [open, setOpen] = useState(defaultOpen);
  const [node, setNode] = config;
  const id = useId();

  useEffect(() => {
    if (isReset) {
      setNode(undefined);
    }
  }, [isReset]);

  const edit_object = {
    type: type,
    actionType: "edit",
    key: parentKey,
    treeId,
    value: name,
  };

  useEffect(() => {
    if (id !== node && open && type === "attribute") {
      setOpen(false);
    }
  }, [node]);

  const ref1 = useRef(null);
  const ref2 = useRef(null);

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger
        ref={ref1}
        onClick={(e) => {
          // if (open === false || id === node) {
          //   setNode(id);
          // }
          if (id !== node) {
            setNode(id);
          }
          e.preventDefault();
          e.stopPropagation();
        }}
        className="w-full"
      >
        <div className="bg-gray-50 border border-gray-200 rounded-sm gap-2 w-full text-left mb-2 flex px-4 py-2 text-md items-center">
          <ConditionRenderer condition={type !== "attribute"}>
            <div
              className="border h-[28px] p-1 border-gray-500 text-gray-500 inline-flex items-center justify-center rounded-md"
              onClick={() => setOpen(!open)}
            >
              <ConditionRenderer condition={open}>
                <Minus size={16} className="translate-y-[0px]" />
                <Plus size={16} className="translate-y-[0px]" />
              </ConditionRenderer>
            </div>
          </ConditionRenderer>

          <div
            onClick={() => {
              if (id !== node) {
                setNode(id);
              }
              setOpen(true);
              setIsReset(false);
            }}
            className="flex justify-between flex-grow relative items-center"
          >
            <span>
              {name}
              <ConditionRenderer
                condition={count && open === false ? true : false}
              >
                <span className="text-sm pl-1">({count})</span>
              </ConditionRenderer>
            </span>
            <ConditionRenderer condition={type === "attribute"}>
              <div className="flex gap-3">
                <Button
                  variant={"outline"}
                  size={"sm"}
                  type="button"
                  className="px-2 text-red-500 border-red-500"
                  onClick={(e) => {
                    e.preventDefault();
                    onTreeMutation({
                      type: type,
                      actionType: "delete",
                      key: parentKey,
                      treeId,
                    });
                  }}
                >
                  <Trash2 />
                </Button>
              </div>
              <div className="flex gap-3">
                <Button
                  variant={"outline"}
                  size={"sm"}
                  type="button"
                  className="px-2"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onTreeMutation({
                      type: type,
                      actionType: "add",
                      key: parentKey,
                      treeId,
                    });
                  }}
                >
                  <Plus />
                </Button>
                <Button
                  variant={"outline"}
                  size={"sm"}
                  type="button"
                  className="px-2 text-red-500 border-red-500"
                  disabled={type === "domain"}
                  onClick={(e) => {
                    e.preventDefault();
                    onTreeMutation({
                      type: type,
                      actionType: "delete",
                      key: parentKey,
                      treeId,
                    });
                  }}
                >
                  <Trash2 />
                </Button>
              </div>
            </ConditionRenderer>
          </div>
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent className="ml-5">{children}</CollapsibleContent>
      <ConditionRenderer condition={id === node}>
        <TreeDetailsStructure
          setActiveRef={setActiveRef}
          ref1={ref1}
          ref2={ref2}
          type={type}
          jsonData={jsonData}
          onTreeChange={onTreeChange}
          parentKey={parentKey}
          defaultValue={name}
          erpListData={erpListData}
          erp_mapping_value={erp_mapping_value}
          cardinality={cardinality}
          document_types={document_types}
          domainType={domainType}
          order_type={order_type}
          parentOrderType={parentOrderType}
          orderTypeList={orderTypeList}
          entityCardinality={entityCardinality}
          onTreeFormSubmit={(prop: any) => {
            onTreeFormSubmit(prop, edit_object);
          }}
          support_multi_doc_type={support_multi_doc_type}
          data_type={data_type}
        />
      </ConditionRenderer>
    </Collapsible>
  );
};
